import { render, staticRenderFns } from "./FrequencySettingsEditSelectFrequencyType.vue?vue&type=template&id=faf3756e"
import script from "./FrequencySettingsEditSelectFrequencyType.vue?vue&type=script&lang=ts"
export * from "./FrequencySettingsEditSelectFrequencyType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faf3756e')) {
      api.createRecord('faf3756e', component.options)
    } else {
      api.reload('faf3756e', component.options)
    }
    module.hot.accept("./FrequencySettingsEditSelectFrequencyType.vue?vue&type=template&id=faf3756e", function () {
      api.rerender('faf3756e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frequency-documents/FrequencySettingsEditSelectFrequencyType.vue"
export default component.exports